export default {
    version: "365",
    buildNumber: "015e037",
    baseUrl: "https://cf-st.sc-cdn.net/d/3hPCMJGREFnd8QMXOQ5qy?go=IgsKCTIBBEgBUFxgAQ%3D%3D&uc=92",
};
